/* ============================================================
   MERIDIO — Sezione bundle a gradini
   Nessuna dipendenza. Nessuna richiesta di rete al caricamento:
   prezzi, titoli e anteprime arrivano dal JSON serializzato da Liquid.
   ============================================================ */
(function () {
  'use strict';

  var TIMEOUT_MS = 10000;

  // Sui mercati con prefisso di lingua (Spagna: /es-es/) ogni percorso del
  // carrello, dello sconto e del checkout deve partire da quel prefisso.
  // Con i percorsi assoluti dalla radice Shopify reindirizza alla versione
  // localizzata e per strada perde il codice sconto: il cliente arriva al
  // checkout a prezzo pieno. Vedi window.Shopify.routes.root, che vale "/"
  // in Italia e "/es-es/" in Spagna.
  function radiceNegozio() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    r = String(r).replace(/\/+$/, '');
    if (r.charAt(0) !== '/') r = '/' + r;
    return r === '/' ? '/' : r + '/';
  }

  function inizializza(radice) {
    if (!radice || radice.dataset.mbPronto === '1') return;

    var datiEl = radice.querySelector('[data-mb-dati]');
    var cta = radice.querySelector('[data-mb-cta]');
    if (!datiEl || !cta) return;

    var dati;
    try {
      dati = JSON.parse(datiEl.textContent);
    } catch (e) {
      return; // JSON malformato: meglio lasciare la pagina intatta che romperla
    }
    var varianti = dati.varianti || {};

    // Ogni gradino porta con sé i propri selettori
    var gradini = Array.prototype.map.call(
      radice.querySelectorAll('[data-mb-gradino]'),
      function (box) {
        return {
          box: box,
          radio: box.querySelector('[data-mb-radio]'),
          scelte: box.querySelector('[data-mb-scelte]'),
          slots: Array.prototype.slice.call(box.querySelectorAll('[data-mb-slot]')),
          righe: Array.prototype.slice.call(box.querySelectorAll('[data-mb-riga]'))
        };
      }
    ).filter(function (g) { return g.radio && g.scelte && g.slots.length; });

    if (!gradini.length) return;

    var riepilogo = radice.querySelector('[data-mb-riepilogo]');
    var elPieno = radice.querySelector('[data-mb-pieno]');
    var elTuo = radice.querySelector('[data-mb-tuo]');
    var elRisparmi = radice.querySelector('[data-mb-risparmi]');
    var elAOrologio = radice.querySelector('[data-mb-a-orologio]');
    var elErrore = radice.querySelector('[data-mb-errore]');

    var testoOriginale = cta.textContent;
    var testoAttesa = cta.dataset.testoAttesa || testoOriginale;
    var testoErrore = cta.dataset.testoErrore || 'Riprova.';
    var testoRegalo = radice.dataset.mbTestoRegalo || '';
    var timer = null;
    var reindirizzo = false;

    // ---------- Importi ----------
    var valuta = dati.valuta || 'EUR';

    function conSeparatori(centesimi, decimali, migliaia, decimale) {
      var parti = (centesimi / 100).toFixed(decimali).split('.');
      var interi = parti[0].replace(/\B(?=(\d{3})+(?!\d))/g, migliaia);
      return parti[1] ? interi + decimale + parti[1] : interi;
    }

    // Fuori dall'euro l'importo è già convertito dal mercato: va scritto con il
    // formato del negozio, mai con il simbolo € appeso a mano.
    function conFormatoNegozio(centesimi) {
      var formato = dati.formato || '';
      if (formato.indexOf('{{') === -1) return conSeparatori(centesimi, 2, '.', ',');
      return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, nome) {
        switch (nome) {
          case 'amount_no_decimals': return conSeparatori(centesimi, 0, ',', '.');
          case 'amount_with_comma_separator': return conSeparatori(centesimi, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return conSeparatori(centesimi, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return conSeparatori(centesimi, 2, "'", '.');
          case 'amount_with_space_separator': return conSeparatori(centesimi, 2, ' ', ',');
          case 'amount_no_decimals_with_space_separator': return conSeparatori(centesimi, 0, ' ', ',');
          default: return conSeparatori(centesimi, 2, ',', '.');
        }
      });
    }

    function euro(centesimi) {
      // In euro resta lo stile italiano di sempre: simbolo dopo la cifra.
      if (valuta === 'EUR') return conSeparatori(centesimi, 2, '.', ',') + ' €';
      return conFormatoNegozio(centesimi);
    }

    function infoDi(idVariante) {
      return varianti[idVariante] || null;
    }

    function prezzoDi(idVariante) {
      var v = infoDi(idVariante);
      return v ? v.prezzo : 0;
    }

    // ---------- Anteprime ----------
    function aggiornaAnteprima(select, immagine) {
      if (!immagine) return;
      var v = infoDi(select.value);
      if (!v || !v.img) return;
      if (immagine.getAttribute('src') !== v.img) immagine.setAttribute('src', v.img);
      immagine.setAttribute('alt', v.titolo || '');
    }

    function aggiornaAnteprimeSlot(slot) {
      var o = slot.querySelector('[data-mb-orologio]');
      var f = slot.querySelector('[data-mb-fune]');
      if (o) aggiornaAnteprima(o, slot.querySelector('[data-mb-anteprima-orologio]'));
      if (f) {
        aggiornaAnteprima(f, slot.querySelector('[data-mb-anteprima-fune]'));
        // Il prezzo barrato segue la variante scelta, se un giorno costassero diverso
        var prezzo = slot.querySelector('[data-mb-prezzo-fune]');
        var info = infoDi(f.value);
        if (prezzo && info) prezzo.textContent = euro(info.prezzo);
      }
    }

    // ---------- Riepilogo dal vivo ----------
    function gradinoScelto() {
      for (var i = 0; i < gradini.length; i++) {
        if (gradini[i].radio.checked) return gradini[i];
      }
      return gradini[0];
    }

    // Conti di un gradino, sui modelli scelti in quel gradino
    function calcola(g) {
      var n = g.slots.length || 1;
      var sconto = parseFloat(g.radio.dataset.sconto);
      if (isNaN(sconto) || sconto < 0) sconto = 0;
      if (sconto > 100) sconto = 100;

      // Quanti orologi di questo gradino sono in regalo (0 = gradino a percentuale)
      var inOmaggio = parseInt(g.radio.dataset.omaggio || '0', 10);
      if (isNaN(inOmaggio) || inOmaggio < 0) inOmaggio = 0;
      if (inOmaggio >= n) inOmaggio = n - 1;

      var pienoOrologi = 0;
      var pienoBracciali = 0;
      var prezziOrologi = [];
      g.slots.forEach(function (slot) {
        var p = prezzoDi(slot.querySelector('[data-mb-orologio]').value);
        prezziOrologi.push(p);
        pienoOrologi += p;
        pienoBracciali += prezzoDi(slot.querySelector('[data-mb-fune]').value);
      });

      var pieno = pienoOrologi + pienoBracciali;
      var tuo;
      if (inOmaggio > 0) {
        // "Ne paghi due, il terzo è in regalo": si toglie il PIÙ ECONOMICO.
        // È il criterio di Shopify sugli sconti compra-X-ricevi-Y, ed è anche
        // il più prudente: se il checkout fosse più generoso il cliente ci
        // guadagna, mai il contrario. Promettere qui più di quanto toglie il
        // carrello è il modo sicuro di farsi abbandonare al pagamento.
        var ordinati = prezziOrologi.slice().sort(function (a, b) { return a - b; });
        var gratis = 0;
        for (var k = 0; k < inOmaggio; k++) gratis += ordinati[k];
        tuo = pienoOrologi - gratis;
      } else {
        tuo = Math.round(pienoOrologi * (1 - sconto / 100));
      }

      return {
        n: n,
        sconto: sconto,
        pieno: pieno,
        tuo: tuo,
        risparmio: pieno - tuo,
        bracciali: pienoBracciali,
        unitario: Math.round(tuo / n),
        // Con modelli diversi è la media: lo stesso criterio del "a orologio"
        pienoUnitario: Math.round(pienoOrologi / n)
      };
    }

    var MAPPA_HTML = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

    function proteggi(testo) {
      return String(testo).replace(/[&<>"']/g, function (c) { return MAPPA_HTML[c]; });
    }

    // Le righe del gradino contengono segnaposto: qui si riempiono.
    // Il testo scritto nel Personalizza viene protetto PRIMA di sostituire i
    // segnaposto, così l'unico HTML che finisce nella pagina è il nostro.
    function interpola(tpl, c) {
      var barrato = '<s>' + proteggi(euro(c.bracciali)) + '</s>';
      var regalo = testoRegalo
        ? '<em class="mb__regalo">' + proteggi(testoRegalo) + '</em>'
        : '';

      return proteggi(tpl)
        .replace(/\{unitario\}/g, proteggi(euro(c.unitario)))
        .replace(/\{pieno\}/g, proteggi(euro(c.pienoUnitario)))
        .replace(/\{totale\}/g, proteggi(euro(c.tuo)))
        .replace(/\{risparmio\}/g, proteggi(euro(c.risparmio)))
        .replace(/\{bracciali\}/g, barrato)
        .replace(/\{regalo\}/g, regalo)
        .replace(/\{sconto\}/g, String(c.sconto))
        .replace(/\{n\}/g, String(c.n));
    }

    // Se cambio modello in un gradino, lo cambio anche negli altri:
    // i tre prezzi a confronto devono parlare dello stesso orologio.
    function propaga(indiceSlot, selettore, valore) {
      gradini.forEach(function (g) {
        var slot = g.slots[indiceSlot];
        if (!slot) return;
        var el = slot.querySelector(selettore);
        if (el && el.value !== valore) el.value = valore;
      });
    }

    function aggiorna() {
      var scelto = gradinoScelto();

      gradini.forEach(function (g) {
        var attivo = g === scelto;
        g.box.classList.toggle('mb__gradino--attivo', attivo);
        g.scelte.hidden = !attivo;
        // I selettori nascosti non devono essere raggiungibili da tastiera
        Array.prototype.forEach.call(g.scelte.querySelectorAll('select'), function (s) {
          s.disabled = !attivo;
        });

        // Ogni gradino mostra i propri numeri, anche quelli non scelti:
        // è su quel confronto che il cliente decide.
        var c = calcola(g);
        g.righe.forEach(function (riga) {
          var tpl = riga.dataset.mbTpl;
          if (tpl) riga.innerHTML = interpola(tpl, c);
        });

        if (attivo) {
          g.slots.forEach(aggiornaAnteprimeSlot);

          if (elPieno) {
            elPieno.textContent = euro(c.pieno);
            // Un barrato uguale al prezzo pieno è solo rumore
            elPieno.hidden = g.radio.dataset.barrato !== '1' || c.risparmio <= 0;
          }
          if (elTuo) elTuo.textContent = euro(c.tuo);
          if (elRisparmi) elRisparmi.textContent = euro(c.risparmio);
          if (elAOrologio) elAOrologio.textContent = euro(c.unitario);

          // c.tuo è quello che il cliente paga davvero: orologi meno lo sconto
          // del gradino, bracciali a zero per il regalo. È la stessa base su
          // cui Shopify decide se la spedizione è gratuita.
          if (window.mdSpedizione) window.mdSpedizione.aggiornaTutte(c.tuo, radice);

          // La barra fissa in basso rispecchia questi numeri: cosi mostra
          // quello che il cliente paga davvero per il gradino scelto, e il
          // suo pulsante aggiunge la stessa identica selezione.
          try {
            /* Foto e nome dell'orologio scelto nel primo posto: la barra
               fissa mostra quello, non la galleria della pagina. Se scelgo
               NOTTURNO sulla scheda di MOSAICO, la barra deve dire NOTTURNO
               e mostrarne la foto. */
            var primoSel = g.slots[0] && g.slots[0].querySelector('[data-mb-orologio]');
            var primoInfo = primoSel ? infoDi(primoSel.value) : null;

            var statoBundle = {
                n: c.n,
                immagine: primoInfo ? primoInfo.img : '',
                titoloOrologio: primoInfo ? primoInfo.titolo : '',
                etichetta: g.radio.dataset.nome || '',
                sconto: c.sconto,
                tuo: c.tuo,
                pieno: c.pieno,
                risparmio: c.risparmio,
                testoTuo: euro(c.tuo),
                testoPieno: euro(c.pieno),
                articoli: articoliScelti(true)
            };
            /* Anche depositato, non solo annunciato: la barra fissa si avvia
               dopo di noi e il primo annuncio non lo sentirebbe. Cosi al suo
               avvio se lo va a leggere invece di restare col prezzo di Liquid. */
            window.mdBundle = statoBundle;
            document.dispatchEvent(new CustomEvent('md:bundle', { detail: statoBundle }));
          } catch (e) { /* un browser senza CustomEvent non deve fermare il bundle */ }
        }
      });

      if (riepilogo) riepilogo.hidden = false;
      nascondiErrore();
    }

    // ---------- Errori e stato del pulsante ----------
    function mostraErrore(messaggio) {
      if (!elErrore) return;
      elErrore.textContent = messaggio;
      elErrore.hidden = false;
    }

    function nascondiErrore() {
      if (!elErrore) return;
      elErrore.hidden = true;
      elErrore.textContent = '';
    }

    function sblocca() {
      cta.disabled = false;
      cta.textContent = testoOriginale;
      if (timer) { clearTimeout(timer); timer = null; }
    }

    function blocca() {
      cta.disabled = true;
      cta.textContent = testoAttesa;
      nascondiErrore();
      if (timer) clearTimeout(timer);
      // Rete che non risponde: il pulsante non resta mai fermo su "Caricamento…"
      timer = setTimeout(function () {
        if (reindirizzo) return;
        sblocca();
        mostraErrore(testoErrore);
      }, TIMEOUT_MS);
    }

    function invia(url, corpo) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(corpo)
      }).then(function (res) {
        return res.json().catch(function () { return null; }).then(function (dato) {
          if (!res.ok) {
            var messaggio = dato && (dato.description || dato.message);
            throw new Error(messaggio || testoErrore);
          }
          return dato;
        });
      });
    }

    // ---------- Stacca un codice sconto rimasto appiccicato ----------
    // I codici restano legati alla SESSIONE, non al carrello: svuotare il
    // carrello non li toglie. Chi e passato dal vecchio bundle si porta dietro
    // MERIDIO2, che ora e disattivato, e al pagamento si vede comparire
    // "inserisci un codice di sconto valido" anche se il prezzo e giusto.
    // Un update con discount vuoto lo stacca senza toccare gli articoli.
    function staccaCodice() {
      return invia(radiceNegozio() + 'cart/update.js', { discount: '' })
        .catch(function () { /* se fallisce si prosegue: il prezzo e comunque corretto */ });
    }

    // ---------- Gli articoli del gradino scelto ----------
    // Serve in due posti: il pulsante "vai al checkout" e il pagamento rapido.
    // Con silenzioso = true non mostra messaggi d'errore: il pagamento rapido
    // lavora in sottofondo e una selezione incompleta deve solo non allinearsi,
    // non far comparire un avviso rosso mentre il cliente sta ancora scegliendo.
    function articoliScelti(silenzioso) {
      var scelto = gradinoScelto();
      var chiave = cta.dataset.etichettaProprieta || 'Offerta';
      var nomeGradino = scelto.radio.dataset.nome || '';
      var etichettaRegalo = cta.dataset.etichettaRegalo || '';

      // Nel gradino che regala un orologio il bracciale va nel carrello gia a
      // prezzo zero, non a prezzo pieno piu sconto: Shopify applica un solo
      // sconto di classe prodotto per ordine, e se se lo prende il bracciale
      // l'orologio in regalo non viene piu scontato.
      var inOmaggio = parseInt(scelto.radio.dataset.omaggio || '0', 10);
      var mappaOmaggio = {};
      if (inOmaggio > 0) {
        try { mappaOmaggio = JSON.parse(cta.dataset.mappaOmaggio || '{}'); }
        catch (e) { mappaOmaggio = {}; }
      }

      var items = [];
      for (var i = 0; i < scelto.slots.length; i++) {
        var selOrologio = scelto.slots[i].querySelector('[data-mb-orologio]');
        var selFune = scelto.slots[i].querySelector('[data-mb-fune]');
        var idOrologio = selOrologio ? parseInt(selOrologio.value, 10) : 0;
        var idFune = selFune ? parseInt(selFune.value, 10) : 0;
        if (!idOrologio || !idFune) {
          if (!silenzioso) mostraErrore(testoErrore);
          return null;
        }
        if (mappaOmaggio[idFune]) idFune = mappaOmaggio[idFune];
        var propOrologio = {};
        propOrologio[chiave] = nomeGradino;
        var propFune = {};
        propFune[chiave] = etichettaRegalo;

        items.push({ id: idOrologio, quantity: 1, properties: propOrologio });
        items.push({ id: idFune, quantity: 1, properties: propFune });
      }
      return items;
    }

    // ---------- Al checkout ----------
    function alCheckout() {
      var items = articoliScelti(false);
      if (!items) return;

      blocca();

      var radice = radiceNegozio();

      // Si svuota SEMPRE, non piu solo quando l'impostazione lo chiede.
      // Da quando esiste l'allineamento per il pagamento rapido, il carrello
      // contiene gia la selezione del bundle: aggiungere senza svuotare
      // raddoppiava l'ordine (4 orologi invece di 2).
      staccaCodice()
        .then(function () { return invia(radice + 'cart/clear.js', {}); })
        .then(function () { return invia(radice + 'cart/add.js', { items: items }); })
        .then(function () {
          reindirizzo = true;
          // Si va dritti al checkout. Lo sconto del bundle non e piu un codice
          // ma lo sconto automatico MERIDIO15, che scatta da solo sul carrello:
          // passare da /discount/<codice> non serve piu e, con il codice
          // disattivato, faceva comparire al cliente "questo codice sconto non
          // e piu valido" proprio davanti al pagamento.
          window.location.href = radice + 'checkout';
        })
        .catch(function (err) {
          // Aggiunta fallita (variante esaurita, rete): non si va al checkout.
          mostraErrore(err && err.message ? err.message : testoErrore);
          sblocca();
        });
    }

    // Il primo orologio del bundle è una variante di questa pagina (es. MURALE nero):
    // la pagina la seleziona, così la foto principale cambia anche col selettore nascosto.
    function avvisaPagina(id) {
      var wrap = document.querySelector('[data-md-variants]');
      var jsonEl = wrap && wrap.querySelector('[data-md-variants-json]');
      if (!jsonEl) return;
      var varianti;
      try { varianti = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var trovata = varianti.find(function (v) { return String(v.id) === String(id); });
      if (!trovata) return;
      var selects = wrap.querySelectorAll('select[data-md-option]');
      selects.forEach(function (sel, k) { sel.value = trovata.options[k]; });
      if (selects.length) selects[0].dispatchEvent(new Event('change'));
    }

    // ---------- Pagamento rapido collegato al bundle ----------
    // I pulsanti Shop Pay / Apple Pay / Google Pay pagano il CARRELLO, non la
    // pagina: non sanno nulla di cosa e selezionato qui. Percio il carrello va
    // allineato PRIMA che il cliente li tocchi — il foglio di pagamento si apre
    // nello stesso istante del tocco e non si puo infilare una richiesta di rete
    // in mezzo senza che iOS consideri il gesto scaduto.
    //
    // L'allineamento parte solo dopo un'azione VERA del cliente (isTrusted): se
    // partisse al caricamento, ogni visitatore si ritroverebbe un carrello pieno
    // senza aver toccato niente, e i dati del funnel non varrebbero piu nulla.
    var rapido = radice.querySelector('[data-mb-rapido]');
    var attesaSync = null;
    var sincronizzando = false;

    function allineaCarrello() {
      if (!rapido || sincronizzando) return;
      var items = articoliScelti(true);
      if (!items) { rapido.hidden = true; return; }
      sincronizzando = true;
      var r = radiceNegozio();
      // Qui si svuota sempre, anche se il pulsante principale non lo fa: questa
      // funzione gira a ogni cambio di selezione e senza svuotare gli articoli
      // si sommerebbero a ogni tocco (4 orologi, 6, 8...).
      staccaCodice()
        .then(function () { return invia(r + 'cart/clear.js', {}); })
        .then(function () { return invia(r + 'cart/add.js', { items: items }); })
        .then(function () { rapido.hidden = false; })
        .catch(function () { rapido.hidden = true; })
        .then(function () { sincronizzando = false; });
    }

    function programmaAllineamento(e) {
      if (!rapido) return;
      if (e && e.isTrusted === false) return;
      rapido.hidden = true;
      if (attesaSync) clearTimeout(attesaSync);
      attesaSync = setTimeout(allineaCarrello, 400);
    }

    // ---------- Ascolto ----------
    gradini.forEach(function (g) {
      g.radio.addEventListener('change', function (e) { aggiorna(); programmaAllineamento(e); });
      g.slots.forEach(function (slot, i) {
        var orologio = slot.querySelector('[data-mb-orologio]');
        var bracciale = slot.querySelector('[data-mb-fune]');
        if (orologio) orologio.addEventListener('change', function (e) {
          propaga(i, '[data-mb-orologio]', orologio.value);
          aggiorna();
          if (i === 0) avvisaPagina(orologio.value);
          programmaAllineamento(e);
        });
        if (bracciale) bracciale.addEventListener('change', function (e) {
          propaga(i, '[data-mb-fune]', bracciale.value);
          aggiorna();
          programmaAllineamento(e);
        });
      });
    });
    cta.addEventListener('click', alCheckout);

    // La pagina prodotto ha cambiato variante (es. MURALE nero invece che argento):
    // il primo orologio di ogni gradino segue la scelta, se quella variante è in lista.
    document.addEventListener('md:variante', function (e) {
      if (!radice.isConnected || !e.detail) return;
      var id = String(e.detail.id);
      gradini.forEach(function (g) {
        var slot = g.slots[0];
        var sel = slot && slot.querySelector('[data-mb-orologio]');
        if (!sel) return;
        var opt = sel.querySelector('option[value="' + id + '"]');
        if (!opt || opt.disabled) return;
        sel.value = id;
        aggiornaAnteprimeSlot(slot);
      });
      aggiorna();
    });

    radice.dataset.mbPronto = '1';
    aggiorna();
  }

  function avvia(contesto) {
    var radice = contesto || document;
    Array.prototype.forEach.call(radice.querySelectorAll('[data-meridio-bundle]'), inizializza);
  }

  avvia();

  // Personalizza tema: la sezione viene ridisegnata a ogni modifica
  document.addEventListener('shopify:section:load', function (e) { avvia(e.target); });
})();
